import { gql, useApolloClient, useMutation, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useHistory } from "react-router-dom";
import { Button } from "../../components/button";
import { Podcast } from "../../components/podcast";
import { SmallButton } from "../../components/small-button";
import { CATEGORY_FRAGMENT, EPISODE_FRAGMENT, PODCAST_FRAGMENT, REVIEW_FRAGMENT } from "../../fragments";
import { deletePodcast, deletePodcastVariables } from "../../__generated__/deletePodcast";
import { myPodcasts } from "../../__generated__/myPodcasts";

export const MY_PODCASTS_QUERY = gql`
  query myPodcasts {
    myPodcasts {
      ok
      error
      podcasts {
        ...PodcastParts
        category {
        ...CategoryParts
        }
        episodes {
        ...EpisodeParts
        }
        reviews {
        ...ReviewParts
        }
      }
    }
  }
  ${PODCAST_FRAGMENT}
  ${CATEGORY_FRAGMENT}
  ${EPISODE_FRAGMENT}
  ${REVIEW_FRAGMENT}
`;

export const MyPodcasts = () => {
    const history = useHistory();
    const { data } = useQuery<myPodcasts>(MY_PODCASTS_QUERY);

    return (
        <div>
            <Helmet>
                <title>My Podcasts | KUDOK</title>
            </Helmet>
            <div className="max-w-screen-2xl mx-auto flex flex-col items-center pt-32 pb-44">
                <h2 className="text-4xl font-medium mb-10">My Podcasts</h2>
                {data?.myPodcasts.ok &&
                    data.myPodcasts.podcasts.length === 0 ? (
                    <>
                        <h4 className="text-xl mb-5">You have no podcasts.</h4>
                        <Button actionText="Create one &rarr;" onClick={() => { history.push("/create-podcast") }}></Button>
                    </>
                ) : (
                    <>
                        <div className="self-end mr-5">
                            <Button actionText="Create Podcast" onClick={() => { history.push("/create-podcast") }}></Button>
                        </div>
                        <div className="grid mt-16 md:grid-cols-3 gap-x-5 gap-y-10">
                            {data?.myPodcasts.podcasts.map((podcast) => (
                                <Podcast
                                    key={Math.random() + podcast.id}
                                    id={podcast.id + ""}
                                    coverImage={podcast.coverImg}
                                    title={podcast.title}
                                    category={podcast.category?.name}
                                    rating={podcast.rating}
                                    createdAt={podcast.createdAt}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};